import angular from 'angular';

class ModalDeleteAnnouncementCtrl {
    /*@ngInject*/
    constructor(AnnouncementSvc, logger) {
        this.AnnouncementSvc = AnnouncementSvc;
        this.logger = logger;
    }

    deleteAnnouncement() {

        let vm = this;
        this.AnnouncementSvc.deleteAnnouncement(vm.resolve.announcement.id).then(
            function (data) {
                vm.logger.success('success.delete', data, null, {
                    entityName: vm.resolve.announcement.announcementContents[0].title,
                });
                vm.modalInstance.close();
            },
            function () {
                vm.logger.error('error.delete');
                vm.cancel();
            }
        );
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }
}

angular.module('app.announcement').component('modalDeleteAnnouncement', {
    templateUrl: require('./modal-delete-announcement.html'),
    controller: ModalDeleteAnnouncementCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
});
